import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

// https://www.gatsbyjs.org/docs/add-seo-component/

const SEO = ({ title, description, image, article, noindex }) => {
    const location = useLocation()
    const { site } = useStaticQuery(query)
    const {
        siteTitle,
        siteDesc,
        siteTagline,
    } = site.siteMetadata

    const seo = {
        title: title || siteTitle,
        tagline: siteTagline,
        description: description || siteDesc,
        image: null,
        url: location.href,
        article: article ? true : null,
        noindex
    }

    return (
        <Helmet title={`${seo.title} | ${seo.tagline}`}>
            <meta name="description" content={seo.description} />
            {seo.image && <meta name="image" content={seo.image} />}

            {seo.url && <meta property="og:url" content={seo.url} />}
            {seo.article && <meta property="og:type" content="article" />}
            {seo.title && <meta property="og:title" content={`${seo.title} | ${seo.tagline}`} />}
            {seo.description && <meta property="og:description" content={seo.description} />}
            {seo.image && <meta property="og:image" content={seo.image} />}

            <meta name="twitter:card" content="summary_large_image" />
            {seo.title && <meta name="twitter:title" content={`${seo.title} | ${seo.tagline}`} />}
            {seo.description && <meta name="twitter:description" content={seo.description} />}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
            {seo.noindex && <meta name="robots" content="noindex, nofollow" />}
        </Helmet>
    )
}

export default SEO

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        siteTitle
        siteDesc
        siteTagline
      }
    }
  }
`
